/* tslint:disable */
/* eslint-disable */
/**
 * BuLLy documentation
 * BuLLy Server
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: info@redcare-pharmacy.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export const CartEntryItemERxV2ErxRedemptionTypeEnum = {
    Scan: 'scan',
    Nfc: 'nfc',
    Upload: 'upload'
};
export const CartEntryItemERxV2MedicationTypeEnum = {
    Pzn: 'pzn',
    Composite: 'composite',
    ActiveSubstance: 'activeSubstance',
    Freetext: 'freetext'
};
export const CartEntryItemERxV2PriceLabelEnum = {
    AfterInvoice: 'afterInvoice',
    SelfPaymentDueToExpiry: 'selfPaymentDueToExpiry',
    SelfPayment: 'selfPayment',
    Copayment: 'copayment',
    CopaymentUpTo: 'copaymentUpTo',
    NoCopayment: 'noCopayment',
    YourPrice: 'yourPrice'
};
export const CartEntryItemERxV2PriceLabelInfoEnum = {
    CallInAnyCase: 'call_in_any_case',
    CallIfGreaterThan50: 'call_if_greater_than_50',
    PriceBetween020: 'price_between_0_20'
};
